import _ from "lodash";

import {
  ERPSeedless,
  ERPRJL,
  ERPUnity,
  ERPOdoo
} from "src/utils/constants";
import { IRoute } from "src/pages/Router/routes";
import { Icons } from "src/library/components/Icon/types";
import { canViewByRoleCodes } from "src/core/shared/utils/canViewByRoleCodes";

import { AdminMain } from "..";
import VanSalesDropsPage from "../VanSalesOrdering/VanSalesDropsPage";
import CustomersPage from "./CustomersPage";
import DropsPage from "./DropsPage";
import PendingCustomersPage from "./PendingCustomersPage";
import EditPendingCustomerPage from "./EditPendingCustomerPage";

const AdminCustomers: IRoute[] = [
  {
    exact: true,
    path: "/admin/customers",
    pageComponent: CustomersPage,
    title: "%CUSTOMERS%",
    icon: Icons.PEOPLEOUTLINE,
    menuType: "ADMIN_CUSTOMERS",
    privateRoute: true,
    parent: AdminMain[ 0 ],
    permissions: [ "view-customer" ],
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo
    ]
  },
  {
    exact: true,
    path: "/admin/users",
    canView: store => canViewByRoleCodes(store, [ "account-manager" ], "DENY"),
    title: "%USERS%",
    icon: Icons.PEOPLE,
    menuType: "ADMIN_CUSTOMERS",
    context: "LIST_USERS",
    privateRoute: true,
    permissions: [ "view-user" ],
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo
    ]
  },
  {
    exact: true,
    path: "/admin/drops",
    pageComponent: DropsPage,
    title: "%DROPS%",
    icon: Icons.BRANCH,
    menuType: "ADMIN_CUSTOMERS",
    privateRoute: true,
    parent: AdminMain[ 0 ],
    permissions: [ "view-branch" ],
    roles: [ "admin" ],
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo
    ]
  },
  {
    exact: true,
    path: "/admin/van-sales-drops",
    pageComponent: VanSalesDropsPage,
    title: "Van sales %DROPS%",
    icon: Icons.VAN,
    menuType: "ADMIN_CUSTOMERS",
    privateRoute: true,
    parent: AdminMain[ 0 ],
    roles: [ "admin" ],
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo
    ],
    modules: [ "van-sales-ordering" ]
  },
  {
    exact: true,
    path: "/admin/pending-customers",
    pageComponent: PendingCustomersPage,
    title: "New %CUSTOMERS%",
    icon: Icons.PEOPLEOUTLINE,
    menuType: "ADMIN_CUSTOMERS",
    privateRoute: true,
    parent: AdminMain[ 0 ],
    permissions: [ "view-customer" ],
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo
    ],
    canView: store => !!store.global.settings?.allowPendingCustomers && canViewByRoleCodes(store, [ "account-manager" ], "DENY")
  }

  // {
  //   exact: true,
  //   path: "/admin/roles",
  //   pageComponent: RolesPage,
  //   title: "Roles",
  //   icon: "people",
  //   menuTitle: "Roles & Permissions",
  //   menuType: "ADMIN_CUSTOMERS",
  //   privateRoute: true,
  //   parent: AdminMain[ 0 ],
  //   permissions: [ "amend-role-permissions" ]
  // }
];

const AdminPendingCustomers: IRoute[] = [
  {
    exact: true,
    path: "/admin/pending-customers/:pendingCustomerId",
    pageComponent: EditPendingCustomerPage,
    title: "Edit pending %CUSTOMER%",
    icon: Icons.PEOPLEOUTLINE,
    parent: _.find(AdminCustomers, route => route.path === "/admin/pending-customers"),
    menuType: "EMPTY",
    privateRoute: true,
    permissions: [ "view-customer" ],
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPOdoo
    ],
    canView: store => !!store.global.settings?.allowPendingCustomers && canViewByRoleCodes(store, [ "account-manager" ], "DENY")
  }
];

export default [ ...AdminCustomers, ...AdminPendingCustomers ];
